import React from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  selectedOutcome: string;
  setSelectedOutcome: (value: string) => void;
  handleInput: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
  horizontalLayout?: boolean;
  highlightedFields: Record<string, boolean>;
};

export const QuoteOutcome: React.FC<Props> = ({
  selectedOutcome,
  setSelectedOutcome,
  handleInput,
  horizontalLayout,
  highlightedFields
}) => {

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOutcome(event.target.value);
    handleInput(event);
  };

  return (
    <div id={`quoteOutcome-${horizontalLayout ? 'main-page' : 'sidebar'}`}>
      <form>
        <fieldset role="radiogroup" className="form-field radio-button-group">
          <div
            style={{
              border: highlightedFields.quoteOutcome ? "0.1rem solid red" : undefined,
              borderRadius: highlightedFields.quoteOutcome ? "0.8rem" : undefined,
            }}
          >
            <div className="" style={{ display: "flex", minWidth: "100%" }}>
              <input
                id={`notQuoted-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                type="radio"
                name="quoteOutcome"
                value="Not Quoted"
                checked={selectedOutcome === "Not Quoted"}
                onChange={handleOptionChange}
              />
              <label
                className="radio"
                htmlFor={`notQuoted-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                style={{ width: "50%", margin: "4px" }}
              >
                <span>Not Quoted</span>
              </label>
              <input
                id={`quote-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                type="radio"
                name="quoteOutcome"
                value="Quote"
                checked={selectedOutcome === "Quote"}
                onChange={handleOptionChange}
              />
              <label
                className="radio"
                htmlFor={`quote-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                style={{ width: "50%", margin: "4px" }}
              >
                <span>Quote</span>
              </label>
            </div>
            <div className="" style={{ display: "flex", minWidth: "100%" }}>
              <input
                id={`sale-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                type="radio"
                name="quoteOutcome"
                value="Sale"
                checked={selectedOutcome === "Sale"}
                onChange={handleOptionChange}
              />
              <label
                className="radio"
                htmlFor={`sale-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                style={{ width: "50%", margin: "4px" }}
              >
                <span>Sale</span>
              </label>
              <input
                id={`followUp-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                type="radio"
                name="quoteOutcome"
                value="Follow-Up"
                checked={selectedOutcome === "Follow-Up"}
                onChange={handleOptionChange}
              />
              <label
                className="radio"
                htmlFor={`followUp-${horizontalLayout ? 'main-page' : 'sidebar'}`}
                style={{ width: "50%", margin: "4px" }}
              >
                <span>Follow-Up</span>
              </label>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  );
};

export default QuoteOutcome;
